export default __webpack_public_path__ + "static/media/HeaderLogo.b45c4373.png";